import { render, staticRenderFns } from "./ModalDeleteConfirmation.vue?vue&type=template&id=4f22a5f4&lang=pug"
import script from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteConfirmation.vue?vue&type=style&index=0&id=4f22a5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports